import "./ModalConfirm.scss";
import { Button } from "@dealer-center/core-components";
import { useEffect, useState } from "react";

interface ModalConfirmProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

export const ModalConfirm = ({
  open = false,
  message,
  onConfirm,
  onClose,
  confirmText,
  cancelText
}: ModalConfirmProps) => {
  const [isVisible, setIsVisible] = useState(open);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (open) {
      setIsVisible(true);
      setIsClosing(false);
    } else if (isVisible) {
      setIsClosing(true);
    }
  }, [open, isVisible]);

  const handleAnimationEnd = () => {
    if (isClosing) {
      setIsVisible(false);
      setIsClosing(false);
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="confirm-modal">
      <div className="confirm-modal-overlay">
        <div
          className={`confirm-modal-shade ${open ? "open" : "close"}`}
          onAnimationEnd={handleAnimationEnd}
        />
        <div className={`confirm-modal-content ${open ? "open" : "close"}`}>
          <div className="confirm-modal-message">
            <span>{message || "Are you sure you want to proceed?"}</span>
          </div>
          <div className="confirm-modal-actions">
            <Button
              analyticsConfiguration={{
                eventName: "",
                eventProperties: undefined
              }}
              buttonStyle="tertiary"
              className="confirm-modal-button confirm-modal-cancel"
              onClick={() => {
                onClose();
              }}
            >
              {cancelText || "No"}
            </Button>
            <Button
              analyticsConfiguration={{
                eventName: "",
                eventProperties: undefined
              }}
              className="confirm-modal-button confirm-modal-confirm"
              onClick={onConfirm}
            >
              {confirmText || "Yes"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
